import { Capacitor } from '@capacitor/core';
import { Browser } from '@capacitor/browser';

/** Assumed public site for App Store Privacy / Support URLs (open when Vercel Production is unlocked). */
export const PUBLIC_SITE_ORIGIN = 'https://money-tracker-seven-taupe.vercel.app';

export const PRIVACY_PATH = '/privacy';
export const TERMS_PATH = '/terms';

export const PUBLIC_PRIVACY_URL = `${PUBLIC_SITE_ORIGIN}${PRIVACY_PATH}`;
export const PUBLIC_TERMS_URL = `${PUBLIC_SITE_ORIGIN}${TERMS_PATH}`;

export const SUPPORT_EMAIL = 'plstudio.app@gmail.com';
export const OPERATOR_NAME = '江柏霖 Po Lin Chiang';
export const PRODUCT_NAME = 'MoneyTrack';
export const PRODUCT_NAME_ZH = '錢跡';

/**
 * Fill this after the App is live on the App Store, e.g.
 * https://apps.apple.com/app/idXXXXXXXX
 * Until then, feedback falls back to email.
 */
export const APP_STORE_URL =
  (typeof import.meta !== 'undefined' && import.meta.env?.VITE_APP_STORE_URL) || '';

export function hasAppStoreListing() {
  return typeof APP_STORE_URL === 'string' && APP_STORE_URL.trim().length > 0;
}

export async function openExternalUrl(url: string) {
  if (!url) return;
  if (Capacitor.isNativePlatform()) {
    await Browser.open({ url });
    return;
  }
  window.open(url, '_blank', 'noopener,noreferrer');
}

export async function openSupportEmail(options?: { subject?: string; body?: string }) {
  const subject = encodeURIComponent(options?.subject || `${PRODUCT_NAME} 意見回饋`);
  const body = encodeURIComponent(options?.body || '');
  const mailto = `mailto:${SUPPORT_EMAIL}?subject=${subject}${body ? `&body=${body}` : ''}`;
  window.location.href = mailto;
}

export async function openAppStoreListing() {
  if (!hasAppStoreListing()) return false;
  await openExternalUrl(APP_STORE_URL.trim());
  return true;
}
